import React from 'react'
import { Link } from "react-router-dom";
import { GrUserAdmin } from "react-icons/gr";
import Logo from '../../components/logo/logo.components';

function PrivacyPolicy() {
  return (
    <main
      className="container-fluid forgot-password-container pb-4"
      style={{ height: "auto" }}
    >
      <nav className="navbar fixed-top navbar-light">
        <Link
          to="/"
          className="navbar-brand"
          style={{ fontSize: "22px", color: "#ffffff" }}
        >
          <Logo size="small" />
        </Link>

        <Link
          to="/"
          className="btn btn-primary btn-login  my-2 my-sm-0 px-4"
          type="submit"
        >
          <GrUserAdmin size="1.2em" style={{ marginRight: "5px" }} /> Login
        </Link>
      </nav>
      <article className="container mt-5 pt-5">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-white">Privacy Policy</h1>
          </div>

          <div className="col-md-12 text-white mt-3">
            <p>
              <strong>Last Updated: April 01, 2026</strong>
            </p>
          </div>

          <div className="col-md-12 text-white mt-4">
            <p>
              3for3 Networking (“we,” “our,” or “us”) respects your privacy and
              is committed to protecting the personal information you share with
              us. This Privacy Policy explains how we collect, use, and protect
              your information when you visit www.3for3networking.com, attend
              our networking events, or engage with our platform in any way.
            </p>

            <ol>
              <li>
                <h5>
                  <strong>Information We Collect</strong>
                </h5>
                <p>We collect the following types of information:</p>
                <ul>
                  <li>
                    <p>
                      <strong>Personal Information</strong>
                    </p>
                    <p>
                      When you register, create an account, or interact with our
                      platform, we may collect:
                    </p>
                    <ul className="mb-3">
                      <li>Full name</li>
                      <li>Email address</li>
                      <li>Job title and business information</li>
                      <li>Profile details and networking preferences</li>
                      <li>Communication history and scheduling activity</li>
                    </ul>
                  </li>

                  <li>
                    <p>
                      <strong>Technical and Usage Data</strong>
                    </p>
                    <p>
                      When you use our website or platform, we may automatically
                      collect:
                    </p>
                    <ul className="mb-3">
                      <li>IP address and browser type</li>
                      <li>Device information</li>
                      <li>Pages visited and time spent</li>
                      <li>
                        Interaction with our features (e.g., call scheduling)
                      </li>
                    </ul>
                  </li>

                  <li>
                    <p>
                      <strong>Payment Information</strong>
                    </p>
                    <p>
                      All payments are securely processed through a third-party
                      provider. We do not store full payment details on our
                      servers.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>How We Use Your Information</strong>
                </h5>
                <p>We use your information to:</p>
                <ul className="mb-3">
                  <li>Create and manage your account</li>
                  <li>Match you with relevant networking connections</li>
                  <li>Schedule and manage networking calls</li>
                  <li>Send event or platform updates</li>
                  <li>Provide support and respond to inquiries</li>
                  <li>Improve our services and platform functionality</li>
                  <li>
                    Send promotional or educational content (you may opt out
                    anytime)
                  </li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>Sharing Your Information</strong>
                </h5>
                <p>
                  We do <strong>not sell or rent</strong> your personal
                  information. We may share it only with:
                </p>
                <ul className="mb-3">
                  <li>
                    Trusted third-party providers who help us operate the
                    platform (e.g., payment processors, scheduling software)
                  </li>
                  <li>
                    Legal or regulatory authorities when required to comply with
                    applicable law or to protect our platform
                  </li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>Cookies and Tracking</strong>
                </h5>
                <p>We use cookies and similar technologies to:</p>
                <ul className="mb-3">
                  <li>Provide essential website functionality</li>
                  <li>Analyze site usage</li>
                  <li>Personalize your experience</li>
                </ul>

                <p>
                  You may disable cookies through your browser settings, but
                  some features may not work as intended.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Your Rights and Choices</strong>
                </h5>
                <p>You have the right to:</p>
                <ul className="mb-3">
                  <li>Access, correct, or delete your personal information</li>
                  <li>
                    Opt out of marketing emails at any time using the
                    unsubscribe link
                  </li>
                  <li>
                    Request data deletion or account removal by contacting us at{" "}
                    <a href="mailto:susan@3for3networking.com">
                      susan@3for3networking.com
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>Data Security</strong>
                </h5>
                <p>
                  We implement reasonable security measures to protect your
                  personal information. However, no method of transmission or
                  storage is 100% secure.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Data Retention</strong>
                </h5>
                <p>
                  We retain your personal information as long as your account is
                  active or as needed to:
                </p>
                <ul className="mb-3">
                  <li>Provide you with services</li>
                  <li>Comply with legal obligations</li>
                  <li>Resolve disputes</li>
                  <li>Enforce our agreements</li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>Children's Privacy</strong>
                </h5>
                <p>
                  Our services are intended for users 18 and older. We do not
                  knowingly collect information from children under 13.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Updates to This Policy</strong>
                </h5>
                <p>
                  We may update this Privacy Policy from time to time. All
                  changes will be posted on this page with a revised “Last
                  Updated” date. Continued use of our services after changes are
                  posted constitutes your acceptance of the updated policy.
                </p>
              </li>
            </ol>

            <h4>
              <strong>Need Assistance?</strong>
            </h4>
            <p>
              For questions or support, contact us at{" "}
              <a href="mailto:susan@3for3networking.com">
                susan@3for3networking.com
              </a>
              .
            </p>
          </div>

        </div>
      </article>
    </main>
  );
}

export default PrivacyPolicy;